import type { Theme } from "@mui/material/styles";

const styles = (theme: Theme) => ({
  inputButton: {
    height: 28,
    marginLeft: 15,
    width: 80,
    "&:focus": {
      outline: 0,
    },
  },
  input: {
    "& .MuiInput-input": {
      fontSize: 13,
    },
  },
  iconButton: {
    padding: "5px 2px",
    "&:focus": {
      outline: 0,
      borderRadius: 5,
    },
    "&:hover": {
      borderRadius: 5,
    },
  },
  iconsButton: {
    "&:focus": {
      outline: 0,
    },
    "&:hover": {
      outline: 0,
    },
  },
  actionContainer: {
    flexGrow: 0,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    flexWrap: "nowrap",
    marginLeft: "auto",
    overflow: "visible",
    "& > button": {
      width: "auto",
      flexShrink: 0,
    },
  },
  searchBarContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 6,
    justifyContent: "space-between",
    flexWrap: "nowrap",
    gap: "4px",
    width: "100%",
    "& > .tabs": {
      flex: "1 1 auto",
      minWidth: 0,
      overflow: "hidden",
    },
    marginTop: 6,
  },
  valueCellContainer: {
    width: "80%",
    maxWidth: "300px",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      width: "100%",
    },
  },
  pagination: {
    "& .MuiMenuItem-root": {
      "&:hover": {
        backgroundColor: theme.palette.darkGray[300],
      },
      "&.Mui-selected": {
        backgroundColor: theme.palette.darkGray.main,
        color: "white",
        "&:hover": {
          backgroundColor: theme.palette.darkGray.main,
        },
      },
    },
  },
  dataNotFound: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 2,
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.primary.main,

    "& > .actions": {
      paddingTop: 2,
      fontSize: 15,
      fontWeight: 600,
    },
  },
  tableFooter: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.white.main}`,
    backgroundColor: theme.palette.darkGray[200],
    position: "relative",
    bottom: 0,
    height: 50,
    width: "100%",
    zIndex: 10,
    flexShrink: 0,
  },
  sbuxLogo: {
    height: 120,
    width: 120,
    maxWidth: 120,
    maxHeight: 120,
    [theme.breakpoints.down("md")]: {
      height: "auto",
      width: "auto",
    },
  },
  cellCheckbox: {
    padding: "0 !important",
    color: `${theme.palette.white.main} !important`,
    "&.Mui-checked": {
      color: `${theme.palette.white.main} !important`,
    },
  },
  disabledContainer: {
    opacity: 0.9,
    pointerEvents: "none",
    userSelect: "none",
    width: "100%",
  },
  enabledContainer: {
    opacity: 1,
    pointerEvents: "auto",
    userSelect: "auto",
    cursor: "auto",
    width: "100%",
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  selectAllColumn: {
    textAlign: "center !important",
    padding: "0 !important",
  },
  tableWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%", // Changed from 75vh
    overflow: "hidden",
  },
  tableBodyWrapper: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    // Add scrollbar styling
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.palette.darkGray[200],
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "4px",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    // For Firefox
    scrollbarWidth: "thin",
    scrollbarColor: `${theme.palette.primary.main} ${theme.palette.darkGray[200]}`,
  },
});

export default styles;
